import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_THEME } from "../../../constants";

const initialState = {
  theme: DEFAULT_THEME,
  landedFacility: "",
  requestMonitor:{},
};

const userPreferencesSlice = createSlice({
  name: "userPreferences",
  initialState,
  reducers: {
    loadUserPreferences: (state, action) => {
      const { preferences } = action.payload;

    if (preferences && typeof preferences === "object") {
        state.theme = preferences.theme || DEFAULT_THEME;
        state.landedFacility = preferences.landedFacility || "";
        state.requestMonitor = preferences.requestMonitor || {};
    } else {
    return { ...initialState };
  }
},

  saveUserPreferences: (state, action) => {
      const { preferences } = action.payload;
      if (preferences && typeof preferences === 'object') {
        if (preferences.theme !== undefined) {
          state.theme = preferences.theme;
        }

        if (preferences.landedFacility !== undefined) {
          state.landedFacility = preferences.landedFacility;
        }
      }
  },

  saveValetRequestMonitor: (state, action) => {
    const { preferences } = action.payload;
    if (preferences && preferences.requestMonitor && typeof preferences.requestMonitor === 'object') {
    
      if (!state.requestMonitor) {
            state.requestMonitor = {};
        }
            Object.entries(preferences.requestMonitor).forEach(([entityId, monitor]) => {
                state.requestMonitor[entityId] = {
                    removeRequestAfter: monitor.removeRequestAfter,
                    numberOfRequests: monitor.numberOfRequests,
                    requestScope: monitor.requestScope,
              };
        });
    }
  },
},
});

export const {
  loadUserPreferences,
  saveUserPreferences,
  saveValetRequestMonitor
} = userPreferencesSlice.actions;

export default userPreferencesSlice.reducer;
